import React, { useContext, forwardRef } from 'react';
import type { InputProps as QuantumInputProps } from '$quantum/atoms/Input';
import { Input as QuantumInput } from '$quantum/atoms/Input';
import { FormItemContext } from './FormItem';

/**
 * @NOTE
 * This is a cloned component for temporary restyling purposes only!
 * It is intended for use ONLY for dynamic route pages which are CMS driven.
 *
 * The Input is to be completely rewritten as a Quantum Component
 * after which this file will be deleted from the project.
 */

export interface InputCmsIntegratedProps extends QuantumInputProps {
  disabled?: boolean;
  label?: string;
  iconId?: string;
}

const Input = forwardRef(
  (
    { onChange, onBlur, disabled, label = '', ...props }: InputCmsIntegratedProps,
    ref: React.Ref<typeof QuantumInput>
  ) => {
    const { field, forLabel, setFocussed } = useContext(FormItemContext);
    const [{ name, value, onChange: fieldOnChange, onBlur: fieldOnBlur }] = field;
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      fieldOnChange(e);
      if (typeof onChange === 'function') onChange(e);
    };
    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      setFocussed(false);
      fieldOnBlur(e);
      if (typeof onBlur === 'function') onBlur(e);
    };
    const handleFocus = () => {
      setFocussed(true);
    };
    const extendProps = { ...props };
    if (forLabel) extendProps.id = forLabel;
    return (
      <QuantumInput
        ref={ref}
        name={name}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        label={label}
        disabled={disabled}
        {...extendProps}
      />
    );
  }
);
Input.displayName = 'Input';
export default Input;
